<template>
  <!-- REMOVIDA a propriedade 'app' daqui -->
  <v-app-bar color="primary"> 
    <v-app-bar-nav-icon @click.stop="$emit('toggle-sidebar')"></v-app-bar-nav-icon>
    <v-toolbar-title>Meu App</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-btn icon @click="$emit('toggle-theme')">
      <v-icon>mdi-theme-light-dark</v-icon>
    </v-btn>
    <v-menu offset-y>
      <template v-slot:activator="{ props }">
        <v-btn icon v-bind="props">
          <v-icon>mdi-account-circle</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item link>
          <v-list-item-title>Mudar Perfil</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
export default {
  name: 'AppNavbar',
  emits: ['toggle-sidebar', 'toggle-theme'], // Boa prática: declarar os eventos emitidos
}
</script>